import requester from '@/lib/axios';
import {
  BlockCodeActivityEditElement,
  BlockCodeActivityElement,
} from '@/models/_deprecated/ActivityElement';
import { ActivityValidationResult } from '@/data/services/activityElement/codeEditorActivityServices';

const baseUrl = 'block-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getBlockActivity = async (questionId: number) => {
  const { data: block } = await requester().get<BlockCodeActivityElement>(
    `${baseUrl}/${questionId}/`,
  );
  return block;
};

export const validateBlockActivity = async (
  activityId: number,
  questionId: number,
) => {
  const { data } = await requester().patch<ActivityValidationResult>(
    `${nestedUrl(activityId)}/${questionId}/validate/`,
  );
  return data;
};

export const createBlockQuestionIntoActivity = async (
  activityId: number,
  body: Omit<BlockCodeActivityEditElement, 'id'>,
) => {
  const { data } = await requester().post<BlockCodeActivityEditElement>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateBlockQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<BlockCodeActivityEditElement>,
) => {
  const { data } = await requester().patch<BlockCodeActivityEditElement>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteBlockQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
